import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions  } from '@angular/http';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { ApiSettings } from '../../api.settings';

@Injectable()
export class LabeledProductService {

  private labeledProductUrl = ApiSettings.API_URL + 'labeledproduct';
  private labeledProducWithExtraInfotUrl = ApiSettings.API_URL + 'labeledproductwithextrainfo';
  private labeledProductWithStockUrl = ApiSettings.API_URL + 'labeledproductwithminstock';
  private saleLabeledProductDistributor = ApiSettings.API_URL + 'saleproductdistributor';
  private labeledProductWithoutCategoryUrl = ApiSettings.API_URL + 'labeledproduct/getlabeledproductwithoutcategory'
  private countLabeledProductWithoutCategoryUrl = ApiSettings.API_URL + 'labeledproduct/getcountlabeledproductwithoutcategory'
  private headers = new Headers({ 'Content-Type': 'application/json' });
  private options = new RequestOptions({ headers: this.headers, withCredentials: true });

  constructor(private http: Http, private router: Router) { };

    parseParams(params: any){
        params = this.cleanEmptyParams(params);  
        let query : string = "?";
        for (var key in params) {
            if (params.hasOwnProperty(key)) {
                if (JSON.stringify(params[key])[0] === '{'){
                    query += key +"="+ JSON.stringify(params[key])+'&';
                }else{
                    query += key +"="+ params[key]+'&';
                }
            }
        }
        if (query[query.length-1] === '&'){
            query = query.substring(0,query.length-1);
        }
        return query;
    }       

    query(params: any): Observable<any> {
        return this.http.get(this.labeledProductUrl + this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    queryWithExtraInfo(params: any): Observable<any> {
        return this.http.get(this.labeledProducWithExtraInfotUrl + this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    queryWithMinStock(params: any): Observable<any> {
        return this.http.get(this.labeledProductWithStockUrl + this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    getLabeledProductsWithoutCategories(params: any): Observable<any> {
        return this.http.get(this.labeledProductWithoutCategoryUrl + this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    getCountLabeledProductsWithoutCategories(params: any): Observable<any> {
        return this.http.get(this.countLabeledProductWithoutCategoryUrl + this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    count(params: any): Observable<any> {
        return this.http.get(this.labeledProductUrl + '/count'+ this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    countWithExtraInfo(params: any): Observable<any> {
        return this.http.get(this.labeledProducWithExtraInfotUrl + '/count'+ this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    countWithMinStock(params: any): Observable<any> {
        return this.http.get(this.labeledProductWithStockUrl + '/count'+ this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    get(id: number): Observable<any> {
        return this.http.get(this.labeledProductUrl +'/'+ id, this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    create(labeledProduct: any): Observable<any> {
        return this.http.post(this.labeledProductUrl, labeledProduct, this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    update(labeledProduct: any): Observable<any> {
        return this.http.put(this.labeledProductUrl +'/'+ labeledProduct.id, labeledProduct, this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    updateStockAndShopStock(labeledProduct: any): Observable<any> {
        return this.http.put(this.labeledProductUrl +'/updatestockandshopstock/'+ labeledProduct.id, labeledProduct, this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    delete(id: number): Observable<any> {
        return this.http.delete(this.labeledProductUrl +'/'+ id, this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    saveProductPhotos(image){
        return this.http.post(this.labeledProductUrl +'/addphoto', image, this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }
    getProductPhotos(productId){
        return this.http.get(this.labeledProductUrl +'/getphotos/'+productId, this.options)
        .map(this.extractData)
        .catch(this.handleError.bind(this));
    }
    deleteProductPhoto(productId, filename){
        return this.http.post(this.labeledProductUrl +'/deletephoto/',{id:productId,filename: filename}, this.options)
        .map(this.extractData)
        .catch(this.handleError.bind(this));
    }

    triggerProductPhotosInP(id: number): Observable<any> {
        return this.http.get(this.labeledProductUrl +'/triggerPhotosInP/'+ id, this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    querySaleLabeledProductDistributor(params: any): Observable<any> {
        return this.http.get(this.saleLabeledProductDistributor + this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    countSaleLabeledProductDistributor(params: any): Observable<any> {
        return this.http.get(this.saleLabeledProductDistributor + '/count'+ this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }
    
    private cleanEmptyParams(params){
        if (params && params.where) {
            for (var filter in params.where) {
                if (!params.where[filter].contains && params.where[filter].contains === "") {
                    delete params.where[filter];
                }
            }
        }
        return params;
    }


    private extractData(res: Response) {
        let body = res.json();
        return body || { };
    }

    private handleError (error: Response | any) {
        if (error.status === 403){
            this.router.navigate(['/login']);
        }
        return Observable.throw(error);
    }

}



// WEBPACK FOOTER //
// ./src/app/labeledproducts/services/labeledproduct.service.ts